var _path, _path2, _g, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTastyCookies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92 49.3C92 53.74 92.48 58.02 91.26 62.06C90.04 66.1 88.92 67.68 86.66 71.14C84.96 73.74 82.32 78.38 80.12 80.56C77.42 83.24 73.24 85.08 69.9 87C66.7 88.84 64.36 90.8 60.7 91.8C57 92.8 53.62 93.04 49.6 93.04C46.76 93.04 43.48 92.68 40.8 92.16C37.8 91.58 34.92 91.12 32.16 89.98C28.86 88.6 26.98 87.04 24.14 84.94C21.1 82.7 17.16 79.88 14.8 76.94C12.56 74.16 11.24 70.88 9.71996 67.6C8.31996 64.56 6.63996 61.56 5.93996 58.2C5.35996 55.34 5.85996 51.76 5.85996 48.72C5.85996 44.88 5.53996 41.78 6.45996 38.24C7.27996 35.06 10.02 30.4 11.48 27.54C13.14 24.3 13.64 22.94 16.02 20.24C17.9 18.1 18.3 18.52 20.56 16.78C23.14 14.8 27.62 10.74 30.6 9.35999C34 7.77999 35.62 7.63999 39.42 6.97999C41.9 6.53999 46.46 5.29999 49.08 5.29999C51.8 5.29999 53.86 5.85999 53.86 5.85999C54.74 15.86 62.92 19.26 65.56 20.42C61.3 37.36 78.46 43.48 81.38 42.78C86.24 48.5 92.14 48.8 92.14 48.8L92 49.3Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_794_1197",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 89,
    height: 89
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.06 93.2C73.3826 93.2 93.1 73.4826 93.1 49.16C93.1 24.8374 73.3826 5.12 49.06 5.12C24.7374 5.12 5.02002 24.8374 5.02002 49.16C5.02002 73.4826 24.7374 93.2 49.06 93.2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_794_1197)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M75.72 47.9C76.4 47.5 77.98 51.56 77.3 51.94C76.62 52.34 75.52 51.6 75.18 51.02C74.86 50.44 75.04 48.3 75.72 47.9Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.98 18.92C51.54 18.36 49.92 16.7 49.36 17.26C48.8 17.82 48.1 19.9 48.58 20.38C49.08 20.86 50.42 19.5 50.98 18.92Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5399 49.38C35.9399 50.06 38.0199 48.32 37.6399 47.64C37.2399 46.96 36.1999 46.74 35.6199 47.08C35.0399 47.42 35.1399 48.7 35.5399 49.38Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0201 31.26C33.4201 31.94 36.8001 29.22 36.4201 28.54C36.0201 27.86 34.7001 27.94 34.1201 28.28C33.5401 28.62 32.6201 30.58 33.0201 31.26Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.14 46.26C16.58 45.76 14.94 43.1 14.5 43.6C14.06 44.1 14.3 44.8 14.66 45.12C15.06 45.46 15.72 46.76 16.14 46.26Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2601 17.02C32.0601 17.3 33.3601 18.24 33.5601 17.96L34.5001 16.64C34.7001 16.36 34.5801 15.92 34.2201 15.66C33.8601 15.4 33.4001 15.42 33.2001 15.7L32.2601 17.02Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.9198 73.72C27.2398 73.32 26.2798 75.86 26.9598 76.26C27.6398 76.66 28.6398 76.32 28.9798 75.74C29.3198 75.18 28.5998 74.12 27.9198 73.72Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.4397 52.22C24.7597 51.82 23.1797 55.88 23.8597 56.26C24.5397 56.66 25.6397 55.92 25.9797 55.34C26.3197 54.76 26.1197 52.62 25.4397 52.22Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0801 86.28C38.4401 87.22 42.0001 88.84 42.6401 87.9C43.2801 86.96 42.9001 85.48 42.1001 84.94C41.3001 84.4 39.7201 85.36 39.0801 86.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48.7402 46.84C48.0602 47.26 49.2202 49.26 49.9002 48.84C50.5802 48.42 51.7802 46.58 51.4202 46C51.0802 45.42 49.4202 46.42 48.7402 46.84Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.7002 77.08C50.4802 76.32 48.0402 77.5 48.2402 78.24C48.4602 79 49.4002 79.46 50.0602 79.28C50.7202 79.1 50.9202 77.84 50.7002 77.08Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.68 69.64C40.9 69.36 39.62 68.38 39.4 68.66L38.42 69.96C38.2 70.24 38.32 70.68 38.68 70.96C39.04 71.22 39.5 71.22 39.7 70.94L40.68 69.64Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M53.3398 88.4C52.6998 89.34 56.2598 90.96 56.8998 90.02C57.5398 89.08 57.1598 87.6 56.3598 87.06C55.5598 86.52 53.9798 87.48 53.3398 88.4Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M58.3597 36.54C58.5797 35.78 62.5198 37.6 62.3197 38.36C62.0997 39.12 60.7997 39.36 60.1597 39.18C59.4997 38.98 58.1397 37.3 58.3597 36.54Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M70.8399 60.94C71.4799 61.88 67.9199 63.5 67.2799 62.56C66.6399 61.62 67.0199 60.14 67.8199 59.6C68.6199 59.06 70.1999 60 70.8399 60.94Z",
    fill: "#231F20"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3203 80.02C57.9603 79.2 57.4003 78.62 58.1803 74.48C58.9603 70.34 56.9003 66.78 61.2803 67.6C65.6403 68.42 69.7403 72.56 68.9603 76.72C68.1803 80.84 66.7003 80.84 62.3203 80.02Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0402 39.06C51.3602 39.62 47.5002 41.36 48.8802 33.94C49.4602 30.84 50.3602 28.36 53.0402 28.86C55.7202 29.36 59.7602 29.56 59.1802 32.66C58.5802 35.78 55.5602 38.76 54.0402 39.06Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0404 66.04C34.2604 65.7 35.3804 64.14 36.0204 60.76C36.6604 57.36 40.4804 55.96 42.2404 56.3C44.0004 56.64 46.4204 58.22 44.6404 61.18C42.9804 63.96 37.8204 66.36 36.0404 66.04Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4 55.74C67.4 55.36 68.38 52.34 68.76 50.34C69.14 48.34 74.06 50.82 73.68 52.8C73.3 54.8 71.38 56.12 69.4 55.74Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3 42.78C23.04 41.2 25.76 39.54 27.34 38.28C28.92 37.02 29.44 43.38 27.86 44.64C26.28 45.88 25.56 44.36 24.3 42.78Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7802 39.54C16.4002 39.08 16.0002 37.18 16.4202 35C16.8202 32.82 17.8802 31.18 20.2602 31.62C22.6402 32.06 24.2602 33.02 23.8602 35.2C23.4402 37.4 21.1602 39.98 18.7802 39.54Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4601 18.74C40.1001 19.2 37.8801 18 37.5401 16.22C37.2001 14.42 41.8601 13.86 44.2201 13.4C46.5801 12.94 45.7601 12.78 46.1001 14.58C46.4601 16.36 44.8401 18.28 42.4601 18.74Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9402 65.96C16.9402 65.58 16.9002 62.38 17.2602 60.38C17.6402 58.38 23.5802 61.04 23.2202 63.04C22.8602 65.02 20.9402 66.34 18.9402 65.96Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5802 71.12C79.5202 70.46 79.7802 68.16 81.1402 65.96C82.5002 63.76 85.5202 63.16 86.5602 63.82C87.6202 64.48 86.3002 66.14 84.9402 68.34C83.6002 70.52 81.6402 71.78 80.5802 71.12Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8602 84.26C47.6802 86.22 46.3802 86.9 45.1002 88.08C43.8202 89.26 42.9402 88.9 41.1202 86.94C39.3002 84.98 38.9802 84.06 40.2402 82.86C41.5202 81.66 44.0402 82.3 45.8602 84.26Z",
    fill: "#231F20"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8804 78.56C56.5204 77.74 55.9604 77.16 56.7404 73.02C57.5204 68.88 55.4604 65.32 59.8404 66.14C64.2004 66.96 68.3004 71.1 67.5204 75.26C66.7204 79.38 65.2404 79.38 60.8804 78.56Z",
    fill: "#4C60E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M60.8804 78.56C56.5204 77.74 55.9604 77.16 56.7404 73.02C57.5204 68.88 55.4604 65.32 59.8404 66.14C64.2004 66.96 68.3004 71.1 67.5204 75.26C66.7204 79.38 65.2404 79.38 60.8804 78.56Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6802 78.7C57.9202 78 57.4402 77.5 58.1002 73.92C58.7802 70.34 57.0002 67.28 60.7602 67.98C64.5202 68.68 68.0602 72.26 67.4002 75.84C66.7202 79.42 65.4402 79.4 61.6802 78.7Z",
    fill: "#4C60E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5802 37.6C49.9002 38.16 46.0402 39.9 47.4202 32.48C48.0002 29.38 48.9002 26.9 51.5802 27.4C54.2602 27.9 58.3002 28.1 57.7202 31.2C57.1402 34.32 54.1002 37.28 52.5802 37.6Z",
    fill: "#4C60E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M52.5802 37.62C49.9002 38.18 46.0402 39.92 47.4202 32.5C48.0002 29.4 48.9002 26.92 51.5802 27.42C54.2602 27.92 58.3002 28.12 57.7202 31.22C57.1402 34.32 54.1002 37.3 52.5802 37.62Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0803 37.86C50.7803 38.34 47.4403 39.84 48.6403 33.46C49.1403 30.78 49.9203 28.66 52.2403 29.08C54.5603 29.52 58.0203 29.68 57.5203 32.36C57.0003 35.02 54.3803 37.6 53.0803 37.86Z",
    fill: "#4C60E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6001 64.52C32.8401 64.18 33.9401 62.62 34.5801 59.24C35.2201 55.84 39.0401 54.44 40.8001 54.78C42.5801 55.12 44.9801 56.7 43.2001 59.66C41.5201 62.46 36.3601 64.86 34.6001 64.52Z",
    fill: "#4C60E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M34.6001 64.52C32.8401 64.18 33.9401 62.62 34.5801 59.24C35.2201 55.84 39.0401 54.44 40.8001 54.78C42.5801 55.12 44.9801 56.7 43.2001 59.66C41.5201 62.46 36.3601 64.86 34.6001 64.52Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7603 64.7C34.2603 64.42 35.2003 63.1 35.7403 60.22C36.2803 57.34 39.5203 56.16 41.0203 56.44C42.5203 56.72 44.5603 58.06 43.0603 60.58C41.6403 62.94 37.2603 64.98 35.7603 64.7Z",
    fill: "#4C60E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.94 54.28C65.94 53.9 66.92 50.88 67.3 48.88C67.68 46.88 72.6 49.36 72.22 51.34C71.84 53.34 69.92 54.66 67.94 54.28Z",
    fill: "#4C60E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M67.94 54.3C65.94 53.92 66.92 50.9 67.3 48.9C67.68 46.9 72.6 49.38 72.22 51.36C71.84 53.36 69.92 54.66 67.94 54.3Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8401 54.46C67.3401 54.18 68.0801 51.9 68.3601 50.4C68.6401 48.9 72.3401 50.76 72.0601 52.26C71.7801 53.74 70.3401 54.74 68.8401 54.46Z",
    fill: "#4C60E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8405 41.32C21.5805 39.74 24.3005 38.08 25.8805 36.82C27.4605 35.56 27.9805 41.92 26.4005 43.18C24.8405 44.42 24.1205 42.9 22.8405 41.32Z",
    fill: "#4C60E5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M22.7804 41.38C21.5204 39.8 24.2404 38.14 25.8204 36.88C27.4004 35.62 27.9204 41.98 26.3404 43.24C24.7604 44.48 24.0404 42.96 22.7804 41.38Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9005 41.56C22.9405 40.34 25.0205 39.06 26.2405 38.1C27.4605 37.14 27.8605 42.02 26.6405 42.98C25.4205 43.96 24.8605 42.78 23.9005 41.56Z",
    fill: "#4C60E5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3202 38.08C14.9402 37.64 14.5402 35.72 14.9602 33.54C15.3602 31.36 16.4202 29.72 18.8002 30.16C21.1802 30.6 22.8002 31.56 22.4002 33.74C22.0002 35.92 19.7002 38.52 17.3202 38.08Z",
    fill: "#4C60E5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M17.3202 38.08C14.9402 37.64 14.5402 35.72 14.9602 33.54C15.3602 31.36 16.4202 29.72 18.8002 30.16C21.1802 30.6 22.8002 31.56 22.4002 33.74C22.0002 35.94 19.7002 38.52 17.3202 38.08Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9803 38.2C15.9803 37.82 15.6403 36.22 16.0003 34.38C16.3403 32.54 17.2403 31.16 19.2403 31.54C21.2403 31.92 22.6203 32.72 22.2603 34.56C21.9003 36.4 19.9803 38.58 17.9803 38.2Z",
    fill: "#4C60E5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0202 17.28C38.6602 17.74 36.4402 16.54 36.1002 14.76C35.7602 12.96 40.4202 12.4 42.7802 11.94C45.1402 11.48 44.3202 11.32 44.6602 13.12C45.0002 14.9 43.3802 16.82 41.0202 17.28Z",
    fill: "#4C60E5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M41.0202 17.28C38.6602 17.74 36.4402 16.54 36.1002 14.76C35.7602 12.96 40.4202 12.4 42.7802 11.94C45.1402 11.48 44.3202 11.32 44.6602 13.12C45.0002 14.9 43.3802 16.82 41.0202 17.28Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.86 17.12C39.94 17.48 38.16 16.52 37.88 15.08C37.6 13.62 41.38 13.16 43.28 12.8C45.2 12.44 44.52 12.3 44.8 13.74C45.08 15.2 43.78 16.76 41.86 17.12Z",
    fill: "#4C60E5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 64.5C15.5002 64.12 15.4602 60.92 15.8202 58.92C16.2002 56.92 22.1402 59.58 21.7802 61.58C21.4002 63.56 19.4802 64.86 17.5002 64.5Z",
    fill: "#4C60E5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M17.5002 64.5C15.5002 64.12 15.4602 60.92 15.8202 58.92C16.2002 56.92 22.1402 59.58 21.7802 61.58C21.4002 63.56 19.4802 64.88 17.5002 64.5Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2403 64.64C16.6603 64.34 16.6203 61.78 16.9003 60.2C17.2003 58.62 21.9203 60.72 21.6403 62.3C21.3403 63.88 19.8203 64.94 18.2403 64.64Z",
    fill: "#4C60E5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1202 69.66C78.0602 69 78.3202 66.7 79.6802 64.5C81.0402 62.3 84.0602 61.7 85.1002 62.36C86.1602 63.02 84.8402 64.68 83.4802 66.88C82.1402 69.06 80.1802 70.32 79.1202 69.66Z",
    fill: "#4C60E5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M79.1202 69.66C78.0602 69 78.3202 66.7 79.6802 64.5C81.0402 62.3 84.0602 61.7 85.1002 62.36C86.1602 63.02 84.8402 64.68 83.4802 66.88C82.1402 69.06 80.1802 70.32 79.1202 69.66Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7201 70.04C79.0001 69.6 79.5201 67.44 80.8801 65.24C82.2401 63.04 84.6601 62.06 85.3801 62.52C86.1001 62.96 84.8601 64.66 83.5001 66.86C82.1401 69.06 80.4401 70.48 79.7201 70.04Z",
    fill: "#4C60E5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4002 82.78C46.2202 84.74 44.9202 85.42 43.6402 86.6C42.3602 87.78 41.4802 87.42 39.6602 85.46C37.8402 83.5 37.5202 82.58 38.7802 81.38C40.0602 80.2 42.5802 80.82 44.4002 82.78Z",
    fill: "#4C60E5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M44.4002 82.8C46.2202 84.76 44.9202 85.44 43.6402 86.62C42.3602 87.8 41.4802 87.44 39.6602 85.48C37.8402 83.52 37.5202 82.6 38.7802 81.4C40.0602 80.22 42.5802 80.84 44.4002 82.8Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7404 83.16C46.1604 84.7 44.9204 85.44 43.6404 86.62C42.3604 87.8 41.6004 87.58 40.1804 86.04C38.7604 84.5 38.5604 83.72 39.8404 82.54C41.1204 81.34 43.3204 81.62 44.7404 83.16Z",
    fill: "#4C60E5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8804 78.56C56.5204 77.74 55.9604 77.16 56.7404 73.02C57.5204 68.88 55.4604 65.32 59.8404 66.14C64.2004 66.96 68.3004 71.1 67.5204 75.26C66.7204 79.38 65.2404 79.38 60.8804 78.56Z",
    stroke: "#1B2772",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5802 37.62C49.9002 38.18 46.0402 39.92 47.4202 32.5C48.0002 29.4 48.9002 26.92 51.5802 27.42C54.2602 27.92 58.3002 28.12 57.7202 31.22C57.1402 34.32 54.1002 37.3 52.5802 37.62Z",
    stroke: "#1B2772",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6001 64.58C32.8401 64.24 33.9401 62.68 34.5801 59.28C35.2201 55.88 39.0401 54.48 40.8001 54.82C42.5801 55.16 44.9801 56.74 43.2001 59.7C41.5201 62.52 36.3601 64.92 34.6001 64.58Z",
    stroke: "#1B2772",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M67.94 54.3C65.94 53.92 66.92 50.9 67.3 48.9C67.68 46.9 72.6 49.38 72.22 51.36C71.84 53.36 69.92 54.66 67.94 54.3Z",
    stroke: "#1B2772",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.84 41.32C21.58 39.74 24.3 38.08 25.88 36.82C27.46 35.56 27.98 41.92 26.4 43.18C24.84 44.44 24.12 42.9 22.84 41.32Z",
    stroke: "#1B2772",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3202 38.08C14.9402 37.64 14.5402 35.72 14.9602 33.54C15.3602 31.36 16.4202 29.72 18.8002 30.16C21.1802 30.6 22.8002 31.56 22.4002 33.74C22.0002 35.94 19.7002 38.52 17.3202 38.08Z",
    stroke: "#1B2772",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0202 17.28C38.6602 17.74 36.4402 16.54 36.1002 14.76C35.7602 12.96 40.4202 12.4 42.7802 11.94C45.1402 11.48 44.3202 11.32 44.6602 13.12C45.0002 14.9 43.3802 16.82 41.0202 17.28Z",
    stroke: "#1B2772",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 64.5C15.5002 64.12 15.4602 60.92 15.8202 58.92C16.2002 56.92 22.1402 59.58 21.7802 61.58C21.4002 63.56 19.4802 64.88 17.5002 64.5Z",
    stroke: "#1B2772",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1202 69.66C78.0602 69 78.3202 66.7 79.6802 64.5C81.0402 62.3 84.0602 61.7 85.1002 62.36C86.1602 63.02 84.8402 64.68 83.4802 66.88C82.1402 69.06 80.1802 70.32 79.1202 69.66Z",
    stroke: "#1B2772",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4002 82.8C46.2202 84.76 44.9202 85.44 43.6402 86.62C42.3602 87.8 41.4802 87.44 39.6602 85.48C37.8402 83.52 37.5202 82.6 38.7802 81.4C40.0602 80.22 42.5802 80.84 44.4002 82.8Z",
    stroke: "#1B2772",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9999 48.76C91.9999 48.94 91.9999 49.12 91.9999 49.3C91.9999 53.74 92.4799 58.02 91.2599 62.06C90.0399 66.1 88.9199 67.68 86.6599 71.14C84.9599 73.74 82.3199 78.38 80.1199 80.56C77.4199 83.24 73.2399 85.08 69.8999 87C66.6999 88.84 64.3599 90.8 60.6999 91.8C57 92.8 53.62 93.04 49.6 93.04C46.76 93.04 43.48 92.68 40.8 92.16C37.8 91.58 34.92 91.12 32.16 89.98C28.86 88.6 26.98 87.04 24.14 84.94C21.1 82.7 17.16 79.88 14.8 76.94C12.56 74.16 11.24 70.88 9.71996 67.6C8.31996 64.56 6.63996 61.56 5.93996 58.2C5.35996 55.34 5.85996 51.76 5.85996 48.72C5.85996 44.88 5.53996 41.78 6.45996 38.24C7.27996 35.06 10.02 30.4 11.48 27.54C13.14 24.3 13.64 22.94 16.02 20.24C17.9 18.1 18.3 18.52 20.56 16.78C23.14 14.8 27.62 10.74 30.6 9.35999C34 7.77999 35.62 7.63999 39.42 6.97999C41.9 6.53999 46.46 5.29999 49.08 5.29999C50.38 5.29999 52.1199 5.53999 53.8599 5.85999C54.6399 12.64 59.2999 18.26 65.5599 20.42C65.1199 21.96 64.8999 23.56 64.8999 25.24C64.8999 34.58 72.1799 42.22 81.3999 42.78C84.0599 45.88 87.7799 48.08 91.9999 48.76Z",
    stroke: "#344054",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTastyCookies);
export default __webpack_public_path__ + "static/media/Tasty_Cookies.b65ef9fbd23931a31030ae06bed50e74.svg";
export { ForwardRef as ReactComponent };